;(function ($) {

    if (!$("body").hasClass("post-type-archive-product")) return;
    console.log('product-archive');
    
    $('.show-all').on('click', function (e) {
        e.preventDefault(); 
        e.stopPropagation();
        
        if (!$(this).parent().hasClass('active')) {
            $(this).parent().addClass('transitioning');
            let parentTop = $(this).parent().offset().top;
            console.log(parentTop);
            $('html, body').animate({
                scrollTop: parentTop
            })
            setTimeout(() => {
                $(this).parent().removeClass('transitioning');
                $(this).parent().addClass('active');
            }, 600);
            $(this).children('span').text('Show Less');
        } else {
            $(this).parent().removeClass('active');
            $(this).children('span').text('Show All');
        }


    });

})(jQuery);